import { logError } from 'client/javascript/util/logger';
import WeGlideWithAutoplay from 'client/javascript/we_glide/we_glide_with_autoplay';
import { TEAMS } from 'shared/rollbar/global_prefixes';

export const HERO_SLIDER_SELECTOR = '.js-home-hero__glide';
export const LOGGING_CONFIG = {
  prefix: '[HomePageHeroSliderWithAutoplayUI]',
  team: TEAMS.MARKETING
};

export function setupHeroSlider() {
  try {
    const moduleDomNode = document.querySelector(HERO_SLIDER_SELECTOR);
    if (moduleDomNode) {
      const glide = new WeGlideWithAutoplay(HERO_SLIDER_SELECTOR);
      glide.mount();
    }
  } catch (error) {
    logError(`${LOGGING_CONFIG.prefix}[setupHeroSlider()] failed`, error, {
      team: LOGGING_CONFIG.team
    });
  }
}
